import {
  HeaderNotificationsAction,
  UserAction
} from '../../types/user-actions';

export const isHeaderNotificationsAction = (
  action?: UserAction
): action is HeaderNotificationsAction => (
  action !== undefined
  && action.eventCategory === 'header-notifications'
);
